
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 2.259 61 58.741","xmlns":"http://www.w3.org/2000/svg","xmlns:bx":"https://boxy-svg.com"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M30.701 41.704l-3.463-5.823-6.537 1.823 1.823-6.537-5.823-3.463 5.823-3.463-1.823-6.537 6.537 1.822 3.463-5.822 3.464 5.822 6.536-1.822-1.822 6.537 5.822 3.463-5.822 3.463 1.822 6.537-6.536-1.823z"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"_Transparent_Rectangle_","data-name":"<Transparent Rectangle>","fill":"none","d":"M13.701 11.704h32v32h-32z"}}),_c('text',{staticStyle:{"white-space":"pre"},attrs:{"x":"10.789","y":"51.945","fill":"#333","font-family":"Roboto","font-size":"11.2"}},[_v('LawNet')]),_c('text',{staticStyle:{"white-space":"pre"},attrs:{"x":"41.955","y":"34.363","fill":"#333","font-family":"Roboto Slab","font-size":"11.2"}}),_c('path',{attrs:{"fill":"none","stroke":"#000","d":"M7.592 9.19h45.152v45.951H7.592z"}})])
          )
        }
      }
    